import { colors } from '@mathflat/common/style'
import clsx from 'clsx'
import { nanoid } from 'nanoid'
import React, { useContext, useEffect, useMemo } from 'react'

import { CheckboxGroupContext } from '@/component/atoms/Checkbox/_context'
import { Icon } from '@/component/atoms/Icon'
import type { DefaultProps } from '@/types'

import S from './FilterChip.style'

export type FilterChipProps = {
  value?: string
  width?: React.CSSProperties['width']
  minWidth?: React.CSSProperties['minWidth']
  rounded?: boolean
  checked?: boolean
  type?: 'default' | 'allCheck'
  disabled?: boolean
  hideCheckIcon?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, next: () => void) => void
} & DefaultProps

const FilterChip = ({
  value,
  width,
  minWidth,
  rounded,
  checked,
  type = 'default',
  disabled,
  hideCheckIcon,
  onChange,
  children,
  className,
  style,
}: FilterChipProps) => {
  const context = useContext(CheckboxGroupContext)!
  const id = useMemo(() => nanoid(), [])

  const _checked =
    checked === undefined ? (value === undefined ? false : context.value?.has(value)) : checked
  const isChecked = type === 'allCheck' ? context.isAllCheck : _checked

  useEffect(() => {
    if (value) {
      context.registChipStore(value)
      type === 'allCheck' && context.setAllCheckValue?.(value)
    }
  }, [])

  useEffect(() => {
    if (context.isAllCheck && value) {
      context.addToValue(value)
    }
  }, [context.isAllCheck])

  return (
    <>
      <input
        name={context.name}
        id={id}
        css={S.input}
        type="checkbox"
        value={value}
        disabled={disabled}
        checked={isChecked}
        onChange={(e) => {
          if (onChange) {
            onChange(e, () => {
              type === 'allCheck' ? context.onChangeALLItemCheck(e) : context.onCheckboxChange(e)
            })
            return
          }
          type === 'allCheck' ? context.onChangeALLItemCheck(e) : context.onCheckboxChange(e)
        }}
      />
      <label
        className={clsx(rounded && 'rounded', className)}
        css={[S.label, width && { width }, minWidth && { minWidth }]}
        style={style}
        htmlFor={id}
      >
        {!disabled && !rounded && !hideCheckIcon && isChecked && (
          <Icon
            className="check-icon"
            name="check"
            size={16}
            color="var(--Colors-Green-500)"
            style={{ marginRight: 2, minWidth: 16 }}
          />
        )}
        <span className={clsx((context.isAllCheck || isChecked) && 'visible')}>{children}</span>
      </label>
    </>
  )
}
export default FilterChip
